import { render } from "./HeaderIcons.vue?vue&type=template&id=04857eec"
import script from "./HeaderIcons.vue?vue&type=script&lang=js"
export * from "./HeaderIcons.vue?vue&type=script&lang=js"

import "./HeaderIcons.vue?vue&type=style&index=0&id=04857eec&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__